import sharedMutations from "@/store/utils/shared-mutations";

const DELETE_FAVOURITE = (state, params) => {
  state.favourites = state.favourites.filter(
    favourite => favourite.Id !== params.id
  );
};

const SET_CHECKED_FAVOURITE = state => {
  state.checkedFavourite = { isFav: true };
};

const UNSET_CHECKED_FAVOURITE = state => {
  state.checkedFavourite = { isFav: false };
};

export default {
  ...sharedMutations,
  DELETE_FAVOURITE,
  SET_CHECKED_FAVOURITE,
  UNSET_CHECKED_FAVOURITE
};
